import React, { forwardRef } from 'react';
import classNames from 'classnames';
import styles from './quantity-unit.module.scss';

export interface QuantityUnitProps extends React.InputHTMLAttributes<HTMLInputElement> {
  unit?: string;
  placeholder?: string;
}

export const QuantityUnit = forwardRef<HTMLInputElement, QuantityUnitProps>(({
  unit = 'kg',
  placeholder,
  className,
  ...props
}, ref) => {
  return (
    <div className={classNames(styles.wrapper, className)}>
      <div className={styles.inputContainer}>
        <input 
          ref={ref}
          type="number"
          step="1"
          className={styles.input}
          placeholder={placeholder}
          {...props} 
        />
        {unit && <span className={styles.unit}>{unit}</span>}
      </div>
    </div>
  );
});

QuantityUnit.displayName = 'QuantityUnit';
